"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Check = _interopRequireDefault(require("../Check"));

var _DropDown2 = _interopRequireDefault(require("../DropDown"));

var _Hotkey = _interopRequireDefault(require("../Hotkey"));

var _dropDown = _interopRequireDefault(require("../icons/drop-down.svg"));

require("./dropDownButton.sass");

var _ref = _react.default.createElement(_dropDown.default, {
  className: "dropDown-icon"
});

var DropDownButton =
/*#__PURE__*/
function (_DropDown) {
  (0, _inherits2.default)(DropDownButton, _DropDown);

  function DropDownButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, DropDownButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DropDownButton).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "preventOpen", function (e) {
      e.stopPropagation();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onChange", function (e) {
      _this.hide();

      _this.props.onChange && _this.props.onChange(e);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onClick", function (e) {
      var disabled = _this.props.disabled;

      if (!disabled) {
        _this.handleClick(e);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(DropDownButton, [{
    key: "render",
    value: function render() {
      var active = this.state.active;
      var _this$props = this.props,
          className = _this$props.className,
          label = _this$props.label,
          Icon = _this$props.Icon,
          indeterminate = _this$props.indeterminate,
          checked = _this$props.checked,
          checkbox = _this$props.checkbox,
          flat = _this$props.flat,
          primary = _this$props.primary,
          small = _this$props.small,
          borderless = _this$props.borderless,
          noUpcase = _this$props.noUpcase,
          disabled = _this$props.disabled,
          shortcut = _this$props.shortcut,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["className", "label", "Icon", "indeterminate", "checked", "checkbox", "flat", "primary", "small", "borderless", "noUpcase", "disabled", "shortcut"]);
      delete props.align;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('btn', 'btn--dropDown', className, {
          'btn--flat': flat,
          'btn--primary': primary,
          'btn--small': small,
          'btn--borderless': borderless,
          'btn--disabled': disabled,
          'btn--noUpcase': noUpcase,
          'btn--active': active
        }),
        ref: "element",
        onClick: this.onClick
      }, _react.default.createElement("span", {
        className: "btn-content"
      }, Icon && _react.default.createElement(Icon, {
        className: 'btn-icon ' + (label ? 'btn-icon--offset' : '')
      }), checkbox ? _react.default.createElement(_Check.default, {
        greyscale: true,
        noInk: true,
        onClick: this.preventOpen,
        onChange: this.onChange,
        checked: checked,
        indeterminate: indeterminate
      }) : label && _react.default.createElement("span", null, label), _ref), shortcut && _react.default.createElement(_Hotkey.default, {
        shortcut: shortcut,
        action: this.onChange
      }), this.renderDropDown());
    }
  }]);
  return DropDownButton;
}(_DropDown2.default);

exports.default = DropDownButton;
(0, _defineProperty2.default)(DropDownButton, "PropTypes", {
  label: _propTypes.default.node,
  Icon: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
  indeterminate: _propTypes.default.bool,
  checked: _propTypes.default.bool,
  checkbox: _propTypes.default.bool,
  className: _propTypes.default.string,
  shortcut: _propTypes.default.string,
  flat: _propTypes.default.bool,
  primary: _propTypes.default.bool,
  small: _propTypes.default.bool,
  borderless: _propTypes.default.bool,
  noUpcase: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onChange: _propTypes.default.func
});